// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './training-detail.scss';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';
import TrainingService from '../../../redux/services/training';

// Utils
import { getPrettyDate, getPrettyDatetime } from '../../../common/utils/date-utils';

class TrainingDetailComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            existingRegistration: false
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        this.setState({
            existingRegistration: false
        });

        TrainingService.checkRegistrationExists({
            associateId: this.props.associate.associateId,
            trainingRef: this.props.training.trainingRef
        }).then((response) => { 
            this.setState({
                existingRegistration: response.exists
            });

            if(!response.exists) {
                let trainings = [];

                for (let i = 0; i < this.props.basketTrainings.length; i++) {
                    trainings.push(this.props.basketTrainings[i]);
                }
        
                trainings.push({
                    trainingRef: this.props.training.trainingRef,
                    title: this.props.training.title,
                    price: this.props.training.price,
                    invoiceItem: this.props.training.invoiceItem
                });
        
                this.props.updateBasket(this.props.basketProducts, trainings);
                this.props.onClose();
            }
        })
        .catch(error => { });
    }

    getTrainerResumeItems(resumeItems, featured) {
        let items = [];

        for (let i = 0; i < resumeItems.length; i++) {
            if(resumeItems[i].featured === featured) {
                items.push(resumeItems[i].resumeItem);
            }
        }

        return items;
    }

    render() {
        return (
            this.props.training ?
                <div className="grid mgt-10">
                    <div className="col-3 t-align-left">
                        <i className="pi pi-globe mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{this.props.training.place}</span>
                    </div>
                    <div className="col-4 t-align-left">
                        <i className="pi pi-calendar mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{getPrettyDatetime(this.props.training.trainingStartDate)}</span>
                    </div>
                    <div className="col-5 t-align-left">
                        <i className="pi pi-stopwatch mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{this.props.t("trainings.labels.duration")} {this.props.training.duration.totalHours}</span>
                    </div>
                    {
                        this.props.training.target !== null && this.props.training.target !== "" ? 
                            <div className="col-12 t-align-left">
                                <i className="pi pi-user mgr-10" style={{fontSize:"1.2rem"}}></i>
                                <span style={{fontSize:"1.2rem"}}>{this.props.training.target}</span>
                            </div>
                            : null
                    }
                    <div className="col-12 mgt-20">
                        <TabView>
                            <TabPanel header={this.props.t("trainings.labels.goals")} style={{fontSize:"1.1rem"}}>
                                {
                                    this.props.training.generalGoals.map((goal) => { 
                                        return <li style={{marginTop:"5px"}}>{goal}</li>;
                                    })
                                }
                            </TabPanel>
                            <TabPanel header={this.props.t("trainings.labels.content")} style={{fontSize:"1.1rem"}}>
                                {
                                    this.props.training.content.map((contentItem) => { 
                                        return <li style={{marginTop:"5px"}}>{contentItem}</li>;
                                    })
                                }
                            </TabPanel>
                            <TabPanel header={this.props.t("trainings.labels.trainers")} style={{fontSize:"1.1rem"}}>
                                <Accordion activeIndex={-1}>
                                    {
                                        this.props.training.trainers.map((trainer) => {
                                            return <AccordionTab header={trainer.name}>
                                                        <div className="grid">
                                                            {
                                                                this.getTrainerResumeItems(trainer.resume, true).map((item) => {
                                                                    return <div className="col-12 t-align-left">
                                                                        <i className="pi pi-briefcase mgr-10"></i>
                                                                        <span>{item}</span>
                                                                    </div>;
                                                                })
                                                            }
                                                        </div>
                                                        <div style={{textAlign:"justify", marginTop: "20px"}}>
                                                            {
                                                                this.getTrainerResumeItems(trainer.resume, false).map((item) => {
                                                                    return <li style={{marginTop:"5px"}}>{item}</li>;
                                                                })
                                                            }
                                                        </div>
                                                    </AccordionTab>;
                                        })
                                    }
                                </Accordion>
                            </TabPanel>
                        </TabView>
                    </div>
                    { this.state.existingRegistration ? <div className='col-12 t-align-left mgt-10'><span className="p-error">{this.props.t("trainings.messages.active-registration")}</span></div> : null  }
                    <div className='col-8 t-align-left mgt-10'>
                        <span className='p-error'>{this.props.t("trainings.labels.limit-date")} {getPrettyDate(this.props.training.registrationEndDate)}.</span>
                    </div>
                    <div className='col-4 t-align-right'>
                        <div className="flex flex-wrap justify-content-end gap-2">
                            <Button label={this.props.t("trainings.labels.register")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() }/>
                        </div>
                    </div>
                </div>
                : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(TrainingDetailComponent));